module["exports"] = [
  "deposit",
  "withdrawal",
  "payment",
  "invoice"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/finance/transaction_type.js
// module id = 2642
// module chunks = 1610